export const SUPPORTED_ADMIN_LANGUAGES = ['en', 'zh'];
export const DEFAULT_ADMIN_LANGUAGE = 'en';

export const normalizeAdminLanguage = (language) => {
  const baseLanguage = String(language || '')
    .trim()
    .toLowerCase()
    .split(/[-_]/)[0];

  return SUPPORTED_ADMIN_LANGUAGES.includes(baseLanguage)
    ? baseLanguage
    : DEFAULT_ADMIN_LANGUAGE;
};
